var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperFoodActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-316.004 -83.199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.914,1.785a15,15,0,1,1-15,15A15,15,0,0,1,16.914,1.785Z",
    transform: "translate(314.09 81.414)",
    fill: "#efac40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,11.58a.709.709,0,0,1-.6-.756.709.709,0,0,1,.6-.755h.625A9.1,9.1,0,0,1,3.269,4.851,6.687,6.687,0,0,1,7.7,2.426a.1.1,0,0,0,0-.011c0-.006,0-.012,0-.018v-.9H7.364c-.341,0-.6-.415-.6-.787A.659.659,0,0,1,7.364,0H9.538a.659.659,0,0,1,.6.707c0,.371-.255.787-.6.787h-.6v.9c0,.007,0,.013,0,.019v.01a6.894,6.894,0,0,1,4.5,2.426,8.936,8.936,0,0,1,2.116,5.217H16.1a.651.651,0,0,1,.6.693c0,.379-.26.818-.6.818Zm1.88-1.511H14.143c-.3-3.541-2.74-6.112-5.8-6.112C5.246,3.957,2.777,6.527,2.476,10.069ZM3.721,8.926c-.034-.391-.1-.357-.014-.581a6.1,6.1,0,0,1,2.255-2.98c.285-.193.27-.245.514-.078.284.195.067.76-.217.952A4.755,4.755,0,0,0,4.5,8.557a.6.6,0,0,1-.549.424c-.035,0-.085.008-.13.008S3.726,8.978,3.721,8.926Z",
    transform: "translate(323.004 92.199)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperFoodActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_food_active_icon.fe98d4a7.svg";
export { ForwardRef as ReactComponent };